import { render, staticRenderFns } from "./BlogPostIndexPage.vue?vue&type=template&id=b109f462&"
import script from "./BlogPostIndexPage.vue?vue&type=script&lang=js&"
export * from "./BlogPostIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports